import { _defineProperty } from "@slyte/core/src/lyte-utils";
import {Route} from "../../../node_modules/@slyte/router/index.js";
let TimeLineComp;

class TimeLine extends Route {
    render() {
       return { outlet: '#zcatcomponent', component: TimeLineComp };
   }

    static actions(arg1) {
        return Object.assign(super.actions({

        }), arg1);
    }

    _() {
        _;
    }

    getRequirements() {
        arguments[1].push(import(
            /* webpackChunkName: "components/javascript/zcat-components/time-line-comp" */
            "../../../components/javascript/zcat-components/time-line-comp"
        ).then(function(res) {
            TimeLineComp = res.TimeLineComp;
        }));

        
;
    }
}

export {TimeLine};

